import script from "./EnvironmentalModifierTaskPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnvironmentalModifierTaskPage.vue?vue&type=script&setup=true&lang=ts"

import "./EnvironmentalModifierTaskPage.vue?vue&type=style&index=0&id=319efba6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319efba6"]])

export default __exports__